import { render, staticRenderFns } from "./delay-management.vue?vue&type=template&id=0f49c697&scoped=true"
import script from "./delay-management.vue?vue&type=script&lang=js"
export * from "./delay-management.vue?vue&type=script&lang=js"
import style0 from "./delay-management.vue?vue&type=style&index=0&id=0f49c697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49c697",
  null
  
)

export default component.exports